import { render, staticRenderFns } from "./Db.vue?vue&type=template&id=68003864"
import script from "./Db.vue?vue&type=script&lang=js"
export * from "./Db.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports